import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { UserRole } from '../../shared/interfaces/user.interface'

/**
 * Ensures PLAYER role users can only access their own player profile.
 * Non-PLAYER roles pass through unaffected.
 */
export const playerProfileGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  const user = authService.currentUser()
  if (!user || user.role !== UserRole.PLAYER) return true

  const routePlayerId = route.paramMap.get('id')
  if (user.player_id && routePlayerId === user.player_id) return true

  return router.createUrlTree(['/unauthorized'])
}
